import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Eye,
  EyeOff,
  Mail,
  Lock,
  Phone,
  User,
  ArrowRight,
  MessageSquare,
  Smartphone,
  Zap,
  Check,
  X,
} from "lucide-react";
import { toast } from "react-toastify";
import registerRequest from "../../../api/Customer/RegisterRequest";
import { registerUser } from "../../../redux/userSlice";

const Register = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState({
    minLength: false,
    hasUppercase: false,
    hasNumber: false,
    hasSpecialChar: false,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Check password strength in real time
  const validatePasswordStrength = (password) => {
    const strength = {
      minLength: password.length >= 8,
      hasUppercase: /[A-Z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password),
    };
    setPasswordStrength(strength);
    return strength;
  };

  // Check if all password requirements are met
  const isPasswordValid = () => {
    return (
      passwordStrength.minLength &&
      passwordStrength.hasUppercase &&
      passwordStrength.hasNumber &&
      passwordStrength.hasSpecialChar
    );
  };

  // Password strength checklist component
  const PasswordStrengthChecklist = ({ password }) => {
    const requirements = [
      {
        label: "At least 8 characters",
        met: passwordStrength.minLength,
      },
      {
        label: "At least one uppercase letter (A-Z)",
        met: passwordStrength.hasUppercase,
      },
      {
        label: "At least one number (0-9)",
        met: passwordStrength.hasNumber,
      },
      {
        label: "At least one special character (!@#$%^&*...)",
        met: passwordStrength.hasSpecialChar,
      },
    ];

    return (
      <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
        <h4 className="mb-3 text-sm font-semibold text-gray-700">
          Password Requirements:
        </h4>
        <div className="space-y-2">
          {requirements.map((requirement, index) => (
            <div
              key={index}
              className="flex items-center space-x-2"
            >
              {requirement.met ? (
                <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
              ) : (
                <X className="w-5 h-5 text-gray-300 flex-shrink-0" />
              )}
              <span
                className={`text-sm font-medium ${
                  requirement.met
                    ? "text-green-700"
                    : "text-gray-500"
                }`}
              >
                {requirement.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  const validationSchema = Yup.object({
    fullName: Yup.string().required("Full name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    phone: Yup.string()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(9, "Must be at least 9 digits")
      .max(12, "Must be at most 12 digits")
      .required("Phone number is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),
    termsAccepted: Yup.boolean()
      .required("You must accept the terms and conditions")
      .oneOf([true], "You must accept the terms and conditions"),
  });

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    try {
      // Ensure the phone number always includes the country code "233"
      let formattedPhone = values.phone.startsWith("233")
        ? values.phone
        : `233${values.phone}`;

      // Check phone length (backend expects max 12)
      if (formattedPhone.length > 12) {
        toast.error("Phone number must not exceed 12 characters.");
        setFieldError("phone", "Phone number must not exceed 12 characters.");
        setSubmitting(false);
        return;
      }

      const payload = {
        full_name: values.fullName,
        phone_number: formattedPhone,
        email: values.email,
        password: values.password,
        password_confirmation: values.confirmPassword,
      };

      const response = await registerRequest.registerUser(payload);
      if(response?.validationErrors){
        Object.keys(response.validationErrors).forEach((field) => {
          const fieldMap = {
            full_name: "fullName",
            phone_number: "phone",
            email: "email",
            password: "password",
            password_confirmation: "confirmPassword",
          };
          const formField = fieldMap[field] || field;
          setFieldError(formField, response.validationErrors[field][0]);
        });
      }

      if (response.success) {
        const { data } = response;

        const userData = data.data?.data;
        const token = data.data?.data?.token;
        const user_slug = data?.data?.data?.user_slug;

        // Save user data to Redux store
        dispatch(
          registerUser({
            userData,
            token,
          })
        );

        toast.success(data.message || "Registration successful!");

        // Navigate based on verification status
        if (!userData.email_verified_at) {
          navigate("/verify-otp", {
            state: {
              user_slug: user_slug,
              email: userData.email,
              phone: userData.phone_number,
              from: "register",
            },
          });
        } else {
          navigate("/dashboard");
        }
      } else {
        const errorData = response.error;
        // const anoda= errorData?.response?.data?.data?.reason || errorData.response?.data?.reason || errorData.message || "An unknown error occurred";
        // const myValidationErrors= response.validationErrors
        // console.log ("myresponse", Object.keys(myValidationErrors)[0]);

        const myValidationErrors = response.validationErrors;

const firstKey = Object.keys(myValidationErrors)[0];
const firstMessage = myValidationErrors[firstKey][0];

console.log("this is firstMessage:", firstMessage);


        // console.log("Anoda:", anoda);

        console.log("Registration errorData:", errorData);  
//comment 
        if (myValidationErrors) {
        const firstErrorKey = Object.keys(myValidationErrors)[0];
        console.log("First error key:", firstErrorKey); 
const firstErrorMessage = myValidationErrors[firstErrorKey][0];
console.log("First error message:", firstErrorMessage);
toast.error(firstMessage);

          Object.keys(errorData.errors).forEach((field) => {
            const fieldMap = {
              full_name: "fullName",
              phone_number: "phone",
              email: "email",
              password: "password",
              password_confirmation: "confirmPassword",
            };

            const formField = fieldMap[field] || field;
            setFieldError(formField, errorData.errors[field][0]);
          });
        } else {
          console.log("Registration error:", errorData);
          toast.error(
            errorData || "Registration failed. Please try again."
          );
        }
      }
    } catch (error) {
      console.error("Registration error:", error);
      // toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen md:flex-row">
      {/* Left section with illustration/info - hidden on mobile, fixed position on desktop */}
      <div
        className={`hidden md:flex w-2/5 bg-red-600 text-white p-16 flex-col justify-between fixed h-screen overflow-hidden transition-opacity duration-500 ease-in-out ${
          isVisible ? "opacity-100" : "opacity-0"
        }`}
      >
        <div>
          <h1 className="mb-6 text-4xl font-bold">Join TXTConnect</h1>
          <p className="mb-8 text-lg opacity-90">
            Create your account to start sending powerful messages to your
            audience.
          </p>

          <div className="mt-10 space-y-6">
            <div className="flex items-start space-x-3">
              <div className="p-2 rounded-full bg-white/20">
                <MessageSquare className="w-5 h-5" />
              </div>
              <div>
                <h3 className="text-lg font-medium">Bulk SMS</h3>
                <p className="text-sm opacity-80">
                  Send messages to thousands of recipients in one go
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <div className="p-2 rounded-full bg-white/20">
                <Smartphone className="w-5 h-5" />
              </div>
              <div>
                <h3 className="text-lg font-medium">Multi-Channel</h3>
                <p className="text-sm opacity-80">
                  SMS, Email, or Voice - choose your preferred method
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <div className="p-2 rounded-full bg-white/20">
                <Zap className="w-5 h-5" />
              </div>
              <div>
                <h3 className="text-lg font-medium">Fast Setup</h3>
                <p className="text-sm opacity-80">
                  Get started in minutes and send your first message
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right section with registration form - full width on mobile, adjusted for fixed sidebar on desktop */}
      <div
        className={`w-full md:w-3/5 p-8 md:p-16 md:ml-[40%] bg-white transition-transform duration-500 ease-in-out ${
          isVisible ? "translate-x-0" : "translate-x-8"
        }`}
      >
        <div className="mx-auto w-full max-w-3xl">
          {/* Mobile-only header with sign in link */}
          <div className="mb-8 text-center md:hidden">
            <p className="text-sm text-gray-600">
              Already have an account?{" "}
              <Link
                to="/login"
                className="font-medium text-red-600 transition-all duration-300 hover:text-red-500"
                state={{ from: location.pathname }}
              >
                Sign in here
              </Link>
            </p>
          </div>

          <div
            className={`text-center md:text-left mb-10 transition-transform duration-500 ease-in-out ${
              isVisible ? "translate-y-0" : "translate-y-4"
            }`}
          >
            <h2 className="text-3xl font-bold text-gray-800">
              Create your account
            </h2>
            <p className="mt-2 text-gray-600">
              Fill in your details to get started
            </p>
          </div>

          <Formik
            initialValues={{
              fullName: "",
              email: "",
              phone: "",
              password: "",
              confirmPassword: "",
              termsAccepted: false,
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, values }) => (
              <Form
                className={`space-y-6 transition-opacity duration-700 ease-in-out ${
                  isVisible ? "opacity-100" : "opacity-0"
                }`}
              >
                {/* Two column layout for form fields */}
                <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                  {/* Full Name Field */}
                  <div>
                    <label
                      htmlFor="fullName"
                      className="block mb-1 text-sm font-medium text-gray-700"
                    >
                      Full Name
                    </label>
                    <div className="relative">
                      <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                        <User className="w-5 h-5 text-gray-400" />
                      </div>
                      <Field
                        type="text"
                        name="fullName"
                        id="fullName"
                        className="block py-3 pl-10 w-full rounded-lg border border-gray-300 shadow-sm transition-all duration-300 outline-none focus:border-red-500 focus:ring-red-500"
                        placeholder="John Doe"
                      />
                    </div>
                    <ErrorMessage
                      name="fullName"
                      component="div"
                      className="mt-1 text-sm text-red-600"
                    />
                  </div>

                  {/* Email Field */}
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-1 text-sm font-medium text-gray-700"
                    >
                      Email
                    </label>
                    <div className="relative">
                      <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                        <Mail className="w-5 h-5 text-gray-400" />
                      </div>
                      <Field
                        type="email"
                        name="email"
                        id="email"
                        className="block py-3 pl-10 w-full rounded-lg border border-gray-300 shadow-sm transition-all duration-300 outline-none focus:border-red-500 focus:ring-red-500"
                        placeholder="your@email.com"
                      />
                    </div>
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="mt-1 text-sm text-red-600"
                    />
                  </div>

                  {/* Phone Field with Ghana Country Code */}
                  <div>
                    <label
                      htmlFor="phone"
                      className="block mb-1 text-sm font-medium text-gray-700"
                    >
                      Phone Number
                    </label>
                    <div className="flex relative">
                      <div className="inline-flex items-center px-3 text-gray-500 bg-gray-50 rounded-l-lg border border-r-0 border-gray-300 shadow-sm transition-all duration-300">
                        <span className="text-sm font-medium">+233</span>
                      </div>
                      <div className="relative flex-1">
                        <div className="flex absolute inset-y-0 left-3 items-center pointer-events-none">
                          <Phone className="w-5 h-5 text-gray-400" />
                        </div>
                        <Field name="phone">
                          {({ field, form }) => (
                            <input
                              {...field}
                              type="tel"
                              id="phone"
                              maxLength="10"
                              className="block py-3 pl-10 w-full rounded-r-lg border border-gray-300 shadow-sm transition-all duration-300 outline-none focus:border-red-500 focus:ring-red-500"
                              placeholder="201234567"
                              onChange={(e) => {
                                let value = e.target.value.replace(/\D/g, ""); // remove non-numeric chars
                                if (value.startsWith("0")) {
                                  value = value.substring(1); // remove leading 0
                                }
                                // restrict input to 10 digits max
                                if (value.length > 10) {
                                  value = value.slice(0, 10);
                                }
                                form.setFieldValue("phone", value);
                              }}
                            />
                          )}
                        </Field>
                      </div>
                    </div>
                    <ErrorMessage
                      name="phone"
                      component="div"
                      className="mt-1 text-sm text-red-600"
                    />
                  </div>

                  {/* Password Field */}
                  <div className="md:col-span-1">
                    <label
                      htmlFor="password"
                      className="block mb-1 text-sm font-medium text-gray-700"
                    >
                      Password
                    </label>
                    <div className="relative">
                      <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                        <Lock className="w-5 h-5 text-gray-400" />
                      </div>
                      <Field name="password">
                        {({ field, form }) => (
                          <input
                            {...field}
                            type={showPassword ? "text" : "password"}
                            id="password"
                            className="block py-3 pl-10 w-full rounded-lg border border-gray-300 shadow-sm transition-all duration-300 outline-none focus:border-red-500 focus:ring-red-500"
                            placeholder="••••••••"
                            onChange={(e) => {
                              field.onChange(e);
                              validatePasswordStrength(e.target.value);
                            }}
                          />
                        )}
                      </Field>
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="flex absolute inset-y-0 right-0 items-center pr-3 transition-all duration-300"
                      >
                        {showPassword ? (
                          <EyeOff className="w-5 h-5 text-gray-400" />
                        ) : (
                          <Eye className="w-5 h-5 text-gray-400" />
                        )}
                      </button>
                    </div>
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="mt-1 text-sm text-red-600"
                    />
                  </div>

                  {/* Confirm Password Field */}
                  <div className="md:col-span-1">
                    <label
                      htmlFor="confirmPassword"
                      className="block mb-1 text-sm font-medium text-gray-700"
                    >
                      Confirm Password
                    </label>
                    <div className="relative">
                      <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                        <Lock className="w-5 h-5 text-gray-400" />
                      </div>
                      <Field
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmPassword"
                        id="confirmPassword"
                        className="block py-3 pl-10 w-full rounded-lg border border-gray-300 shadow-sm transition-all duration-300 outline-none focus:border-red-500 focus:ring-red-500"
                        placeholder="••••••••"
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        className="flex absolute inset-y-0 right-0 items-center pr-3 transition-all duration-300"
                      >
                        {showConfirmPassword ? (
                          <EyeOff className="w-5 h-5 text-gray-400" />
                        ) : (
                          <Eye className="w-5 h-5 text-gray-400" />
                        )}
                      </button>
                    </div>
                    <ErrorMessage
                      name="confirmPassword"
                      component="div"
                      className="mt-1 text-sm text-red-600"
                    />
                  </div>
                </div>

                {/* Password Strength Checklist */}
                <PasswordStrengthChecklist password="" />

                {/* Terms and Conditions Checkbox - full width */}
                <div className="flex items-start mt-6">
                  <div className="flex items-center h-5">
                    <Field
                      type="checkbox"
                      name="termsAccepted"
                      id="termsAccepted"
                      className="w-4 h-4 text-red-600 rounded border-gray-300 transition-all duration-300 focus:ring-red-500"
                    />
                  </div>
                  <div className="ml-3 text-sm">
                    <label htmlFor="termsAccepted" className="text-gray-700">
                      I agree to the{" "}
                      <Link
                        to="/terms-and-conditions"
                        className="font-medium text-red-600 transition-all duration-300 hover:text-red-500"
                      >
                        Terms and Conditions
                      </Link>{" "}
                      and{" "}
                      <Link
                        to="/privacy-policy"
                        className="font-medium text-red-600 transition-all duration-300 hover:text-red-500"
                      >
                        Privacy Policy
                      </Link>
                    </label>
                    <ErrorMessage
                      name="termsAccepted"
                      component="div"
                      className="mt-1 text-sm text-red-600"
                    />
                  </div>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={isSubmitting || !isPasswordValid() || !values.termsAccepted}
                  className="flex relative justify-center px-4 py-3 mt-6 w-full font-medium text-white bg-red-600  rounded-lg border border-transparent shadow-md transition-all duration-300 group hover:from-red-700 hover:to-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? "Creating account..." : "Create Account"}
                  {!isSubmitting && (
                    <ArrowRight className="ml-2 w-5 h-5 transition-transform duration-150 group-hover:translate-x-1" />
                  )}
                </button>

                <div className="mt-12 text-center">
                  <p className="text-sm opacity-80">
                    Already have an account?{" "}
                    <Link
                      to="/login"
                      className="font-medium text-red-600 underline transition-all duration-300 hover:text-red-500"
                      state={{ from: location.pathname }}
                    >
                      Log in
                    </Link>
                  </p>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Register;
